// extracted by mini-css-extract-plugin
export default {"card":"e1-z","carouselContainer":"f1-z","carouselContent":"g1-z"};